import type { Reference } from "../Reference.js";
import { referencesPathMap } from "./referencesPathMap.js";

export function getReferenceDetailPath(reference: Pick<Reference, "locale" | "urlSlug">): string {
	return `${referencesPathMap[reference.locale]}/${reference.urlSlug}`;
}
